export function buildCheckoutUrl(paymentLink, requestId) {
  if (!paymentLink || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(requestId)) return "";
  try {
    const url = new URL(paymentLink);
    if (url.protocol !== "https:" || url.hostname !== "buy.stripe.com" || url.username || url.password) return "";
    url.searchParams.set("client_reference_id", requestId);
    return url.toString();
  } catch {
    return "";
  }
}